import { FC } from 'react';

import { Skeleton } from '../Skeleton/Skeleton';
import { Stack } from '../Stack/Stack';
import { TextStyle } from '../Typography/TextStyle/TextStyle';
import { StyledProgressBar } from './ProgressBar.styles';

export type ThickNess = 'fat' | 'thin';

export type Color = 'green' | 'indigo' | 'red';

export type Props = {
	count: number;
	max: number;
	timer?: boolean;
	indeterminate?: boolean;
	thickness?: ThickNess;
	color?: Color;
	showPercentage?: boolean;
};

export const ProgressBar: FC<Props> & { Skeleton: FC } = ({
	count = 0,
	max,
	timer = false,
	indeterminate = false,
	thickness = 'thin',
	color = 'indigo',
	showPercentage = false,
}) => {
	const completionRate = Math.ceil((count / max) * 100);
	return (
		<Stack spacing="tight" align="center">
			<StyledProgressBar
				completionRate={completionRate}
				timer={timer ? max : undefined}
				indeterminate={indeterminate}
				thickness={thickness}
				color={color}
			/>
			{showPercentage && (
				<TextStyle variation="subdued" tw="min-w-7">
					{completionRate}%
				</TextStyle>
			)}
		</Stack>
	);
};

const ProgressBarSkeleton: FC = () => {
	return (
		<Stack spacing="tight" align="center">
			<Skeleton width="100%" height="10px" />
		</Stack>
	);
};

ProgressBar.Skeleton = ProgressBarSkeleton;

export default ProgressBar;
